import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const slides = [
  {
    id: "hero-ci-ke",
    image:
      "https://readdy.ai/api/search-image?query=a%20lone%20female%20swordsman%20in%20flowing%20dark%20robes%20standing%20amid%20misty%20mountains%20at%20dusk%20cinematic%20Chinese%20martial%20arts%20key%20art%20wide%20composition%20dramatic%20moody%20lighting%20soft%20film%20grain%20elegant%20minimal%20warm%20neutral%20and%20rose%20tones%20high%20detail&width=1920&height=1080&seq=hero-cikeniyingniang&orientation=landscape",
    eyebrow: "戛纳电影节最佳导演作品",
    title: "刺客聂隐娘",
    subtitle: "侯孝贤执导 · 一段关于道义与抉择的孤独之旅",
    link: "/works/ci-ke-nie-ying-niang-2015",
  },
  {
    id: "hero-three-times",
    image:
      "https://readdy.ai/api/search-image?query=a%20graceful%20woman%20under%20soft%20window%20light%20in%20a%20nostalgic%20room%20across%20three%20eras%20cinematic%20Chinese%20romance%20key%20art%20wide%20composition%20dramatic%20moody%20lighting%20soft%20film%20grain%20elegant%20minimal%20warm%20neutral%20and%20rose%20tones%20high%20detail&width=1920&height=1080&seq=hero-zuihaodeshiguang&orientation=landscape",
    eyebrow: "金马奖最佳女主角",
    title: "最好的时光",
    subtitle: "三段跨越时代的爱情 · 一人分饰三角的演技巅峰",
    link: "/works/zui-hao-de-shi-guang-2005",
  },
  {
    id: "hero-journey",
    image:
      "https://readdy.ai/api/search-image?query=a%20fearless%20female%20demon%20hunter%20in%20flowing%20robes%20in%20a%20misty%20ancient%20courtyard%20at%20night%20cinematic%20Chinese%20fantasy%20key%20art%20wide%20composition%20dramatic%20moody%20lighting%20soft%20film%20grain%20elegant%20minimal%20warm%20neutral%20and%20rose%20tones%20high%20detail&width=1920&height=1080&seq=hero-xiyouxiangmo&orientation=landscape",
    eyebrow: "华语奇幻票房神话",
    title: "西游·降魔篇",
    subtitle: "周星驰执导 · 敢爱敢恨的段小姐",
    link: "/works/xi-you-jiang-mo-2013",
  },
];

export default function HeroCarousel() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => window.clearInterval(timer);
  }, []);

  const go = (dir: number) => {
    setActive((prev) => (prev + dir + slides.length) % slides.length);
  };

  return (
    <section className="relative w-full h-[560px] md:h-[680px] overflow-hidden bg-foreground-950">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === active ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={slide.image}
            alt={`${slide.title} 舒淇影视作品焦点海报`}
            title={`${slide.title} 舒淇代表作`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/45 to-foreground-950/20" />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-foreground-950/30" />
        </div>
      ))}

      <div className="relative z-10 h-full max-w-content mx-auto px-4 md:px-8 flex items-center">
        <div className="max-w-xl">
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={index === active ? "block animate-fade-up" : "hidden"}
            >
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-xs font-label tracking-wide">
                <i className="ri-award-line" />
                {slide.eyebrow}
              </span>
              <h1 className="mt-5 font-heading text-4xl md:text-6xl font-bold text-background-50 leading-tight">
                {slide.title}
              </h1>
              <p className="mt-4 text-sm md:text-base text-background-100/90 leading-relaxed">
                {slide.subtitle}
              </p>
              <div className="mt-8 flex flex-wrap items-center gap-3">
                <Link
                  to={slide.link}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50 text-foreground-950 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-play-circle-line text-lg" />
                  查看作品详情
                </Link>
                <Link
                  to="/works"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-50/40 text-background-50 text-sm font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
                >
                  全部作品
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      <button
        type="button"
        onClick={() => go(-1)}
        aria-label="上一张"
        className="hidden md:flex absolute left-6 top-1/2 -translate-y-1/2 z-20 w-11 h-11 items-center justify-center rounded-full bg-background-50/15 text-background-50 border border-background-50/30 hover:bg-background-50/25 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-2xl" />
      </button>
      <button
        type="button"
        onClick={() => go(1)}
        aria-label="下一张"
        className="hidden md:flex absolute right-6 top-1/2 -translate-y-1/2 z-20 w-11 h-11 items-center justify-center rounded-full bg-background-50/15 text-background-50 border border-background-50/30 hover:bg-background-50/25 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-2xl" />
      </button>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {slides.map((slide, index) => (
          <button
            key={slide.id}
            type="button"
            onClick={() => setActive(index)}
            aria-label={`切换到第${index + 1}张`}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              index === active ? "w-8 bg-accent-400" : "w-4 bg-background-50/50"
            }`}
          />
        ))}
      </div>
    </section>
  );
}